import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import {default as GroupAddIcon, default as GroupIcon} from '@mui/icons-material/Group';
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Popover from "@mui/material/Popover";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material";
import Individual from 'marketplace/entities/individual/individual';
import MessagingAPIService from 'messaging/api/messaging-api-service';
import Forum from 'messaging/entities/forum/forum';
import {UserAvatarMap} from 'messaging/entities/forum/view/components/chat';
import * as React from 'react';
import {useSession} from 'users/session/session-context';
import Subscriber from 'messaging/values/subcriber/subscriber';

const SubscriberMenu = styled(Popover)(
  () => ({
    zIndex: 99999
  }))
const SubscriberNotificationList = styled(List)(
  ({theme}) => ({
    maxHeight: theme.spacing(40),
    overflowY: 'auto',
    maxWidth: theme.spacing(50),
    minWidth: theme.spacing(30)
  }));
const SubscriberIcon = styled(IconButton)(
  () => ({
    alignSelf: 'center',
    color: '#666',
    height: 'fit-content',
    marginLeft: 'auto',
    display: 'flex'
  }));

type ChatComponentProps = {
  subscribers: Individual[];
  forum: Forum | undefined;
  avatars: UserAvatarMap;
  disableLeaveButton?: boolean;
  onAddSubscriber: () => void;
  onLeaveConversation: () => void;
}

export default function SubscribersComponent(props: Readonly<ChatComponentProps>) {
  const {
    subscribers,
    forum,
    avatars,
    disableLeaveButton,
    onAddSubscriber,
    onLeaveConversation
  } = props;

  const [menuAnchor, setMenuAnchor] = React.useState<HTMLElement | null>(null);
  const session = useSession();

  async function leaveConversation() {
    if (!forum) return;
    const messageService = new MessagingAPIService(session);
    if (subscribers.length === 1) {
      await messageService.deleteForum(forum);
    } else {
      const newSubscribers = subscribers.filter(subscriber => subscriber.id !== session?.user?.id);
      forum.subscribers = newSubscribers.map(individual => new Subscriber(individual.userId, individual.entityId!));
      await messageService.updateSubscribersForForum(forum);
    }
    onLeaveConversation();
  }

  return (
    <React.Fragment>
      <Tooltip title="Subscriber List">
        <span style={{alignContent: 'center'}}>
          <SubscriberIcon
            aria-label="open subscriber list"
            disabled={!forum}
            onClick={(event) => setMenuAnchor(menuAnchor ? null : event.currentTarget)}
            size="large">
            <Badge badgeContent={subscribers?.length}>
              <GroupIcon/>
            </Badge>
          </SubscriberIcon>
        </span>
      </Tooltip>
      <SubscriberMenu
        anchorEl={menuAnchor}
        anchorOrigin={{vertical: "bottom", horizontal: "right"}}
        transformOrigin={{vertical: "top", horizontal: "right"}}
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}>
        <SubscriberNotificationList dense>
          {subscribers.map((subscriber: Individual) => (
            <ListItemButton
              // onClick={(event) => this.handleSubscriberClick(event, subscriber)}>
              key={subscriber.id.value}>
              <ListItemAvatar>
                <Avatar src={avatars[subscriber.id.value]}/>
              </ListItemAvatar>
              <ListItemText
                primary={subscriber.getFullName()}
                secondary={subscriber.company?.profile?.name}/>
            </ListItemButton>
          ))}
        </SubscriberNotificationList>
        <Divider/>
        {forum?.creator &&
            <List dense>
                <ListItemButton onClick={() => {
                  setMenuAnchor(null);
                  onAddSubscriber();
                }}>
                    <ListItemIcon><GroupAddIcon/></ListItemIcon>
                    <ListItemText>Add People</ListItemText>
                </ListItemButton>
              {!disableLeaveButton &&
                  <ListItemButton onClick={() => {
                    setMenuAnchor(null);
                    void leaveConversation();
                  }}>
                      <ListItemIcon><ExitToAppIcon/></ListItemIcon>
                      <ListItemText>Leave Conversation</ListItemText>
                  </ListItemButton>
              }
            </List>}
      </SubscriberMenu>
    </React.Fragment>
  );
}